import React, { useState } from "react";
import RegistrationForm from "./Components/RegistrationForm";
import ProfessionalExperience from "./Components/ProfessionalExpertise";
import ResumeUpload from "./Components/ResumeUpload";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";


export default function MultiStepForm() {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    // const [submissionComplete, setSubmissionComplete] = useState(false);
    const [formData, setFormData] = useState({
        first_name: "", 
        last_name: "", 
        email: "", 
        country: "", 
        city: "",
        agreeTerms: false,
        agreePrivacy: false,
        role: "",
        work_experience: undefined,
        primary_skill: "",
        skill_experience: undefined,
        english_proficiency: "",
        // experiences: [], 
        resume: null
    });

    const handleNext = () => {
        if (step === 3) {
            // Final step - navigate to success page
            navigate("/talents/success");
        } else {
            setStep(prev => prev + 1);
        }
    };
    const handleBack = () => setStep((prev) => prev - 1);

    const updateFormData = (newData) => {
        setFormData((prev) => ({ ...prev, ...newData }));
    };

    return (
        
        <Box>
            {step === 1 && (
                
                <RegistrationForm
                    data={formData}
                    updateData={updateFormData}
                    onNext={handleNext}
                />
            )}
            {step === 2 && (
                <ProfessionalExperience
                    data={formData}
                    updateData={updateFormData}
                    onNext={handleNext}
                    onBack={handleBack}
                />
            )}
            {step === 3 && (
                <ResumeUpload
                    data={formData}
                    updateData={updateFormData}
                    onBack={handleBack}
                    onNext={handleNext}
                />
            )}
            
        </Box>
        
    );
}
